export const whether = [
  {
    key: '1',
    value: '是',
  },
  {
    key: '0',
    value: '否',
  },
]

// export const ACCEPT_FILE = 'image/*,.bmp,.png,.xls,.doc,.pptx,.xlsx'
export const ACCEPT_FILE = '*'
export const IMAGE_FILE = 'image/*,.pdf'
export const CHECK_STATUS = [
  {
    status: 0,
    color: 'var(--info)',
    text: '草稿',
    btn: 'default',
  },
  {
    status: 1,
    color: 'var(--warning)',
    text: '待审核',
    btn: 'warning',
  },
  {
    status: 2,
    color: 'var(--success)',
    text: '审核通过',
    btn: 'success',
  },
  {
    status: 3,
    color: 'var(--error)',
    btn: 'danger',
    text: '审核不通过',
  },
]
export const checkFilterTool = {
  initCheck: (val) => val === null,
  isNotCheck: (val) => val !== null && +val === 0,
  isWaitCheck: (val) => +val === 1,
  isPassCheck: (val) => +val === 2,
  isRefuseCheck: (val) => +val === 3,
  canRecycle: (val) => +val === 1 || +val === 3,
}
